
import { clone } from '@/utils/enerFunctions'
import EnerEchartsBar from '@/components/enerEcharts/enerEchartsBar'
import EnerEchartsLine from '@/components/enerEcharts/enerEchartsLine'

export default {
  name: 'ForesightChartContainer',
  components: { EnerEchartsLine, EnerEchartsBar },
  props: {
    type: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    minValue: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      initOptions: {
        height: null
      },
      updateOptions: {
        notMerge: true
      },
      valueData: [],
      colorData: []
    }
  },
  computed: {
    // ...mapGetters({
    //   regions: 'regions',
    //   world: 'world',
    //   defaultChartZoneCodes: 'defaultChartZoneCodes',
    //   mapCountry: 'page/mapCountry',
    //   benchmarkCountries: 'page/benchmarkCountries'
    // }),
    baseChartType () {
      switch (this.type) {
        case 'line-gap-stacked':
          return 'line'
        default :
          return 'bar'
      }
    },
    option () {
      const option = {
        dataset: {
          source: this.valueData
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          name: this.unit,
          nameLocation: 'middle',
          nameRotate: 90,
          nameGap: 40,
          min: this.minValue,
          nameTextStyle: {
            fontSize: 14
          }
        }
      }
      const n = this.data.length
      switch (this.type) {
        case 'decomposition':
          option.xAxis = {
            type: 'category',
            axisLabel: {
              interval: 0,
              width: 100,
              overflow: 'break'
            }
          }
          option.series = []
          for (let i = 1; i < n; i++) {
            const serie = {
              name: 'income',
              type: 'bar',
              stack: 'Total',
              seriesLayoutBy: 'row'
            }
            if (i === 1) {
              serie.itemStyle = {
                borderColor: 'transparent',
                color: 'transparent'
              }
              serie.emphasis = {
                itemStyle: {
                  borderColor: 'transparent',
                  color: 'transparent'
                }
              }
            } else {
              serie.color = this.getColorForForesight(i)
              serie.label = {
                show: true,
                position: 'inside',
                fontSize: 14,
                fontWeight: 'bold',
                formatter: (params) => {
                  let sign = ''
                  if (params.value[2] !== null) {
                    sign = '+'
                  } else if (params.value[3] !== null) {
                    sign = '-'
                  }
                  return sign + Math.round(params.value[params.seriesIndex + 1]) + ' ' + this.unit
                }
              }
            }
            option.series.push(serie)
          }
          return option
        case 'line-gap-stacked':
          // option.tooltip = {
          //   trigger: 'axis',
          //   axisPointer: {
          //     type: 'cross',
          //     label: {
          //       backgroundColor: '#6a7985'
          //     }
          //   }
          // }
          option.legend = {}
          option.xAxis = [
            {
              type: 'category',
              boundaryGap: false,
              axisLabel: {
                interval: 0,
                width: 100,
                overflow: 'break'
              }
            }
          ]
          option.series = []
          option.legend.data = []
          for (let i = 1; i < n; i++) {
            const serie = {
              name: this.data[i][0],
              showSymbol: false,
              type: 'line',
              color: this.getColorForForesight(i),
              smooth: true,
              seriesLayoutBy: 'row'
            }
            if (i < (n - 1)) {
              if ((i > 1)) {
                serie.areaStyle = {
                  opacity: 1
                }
                serie.lineStyle = {
                  width: 0
                }
                option.legend.data.push({ name: this.data[i][0], icon: 'rect' })
              } else {
                serie.lineStyle = {
                  width: 4
                }
                option.legend.data.push({ name: this.data[i][0] })
              }
              serie.stack = 'Total'
            } else {
              serie.lineStyle = {
                type: 'dotted',
                width: 4
              }
            }
            option.series.push(serie)
          }
          return option
        case 'column-stacked':
          // option.tooltip = {
          //   trigger: 'axis',
          //   axisPointer: {
          //     // Use axis to trigger tooltip
          //     type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          //   }
          // }
          option.legend = {}
          option.xAxis = {
            type: 'category',
            axisLabel: {
              interval: 0,
              width: 60,
              overflow: 'break'
            }
          }
          option.series = []
          for (let i = 1; i < n; i++) {
            option.series.push({
              name: this.data[i][0],
              type: 'bar',
              stack: 'total',
              color: this.getColorForForesight(i),
              seriesLayoutBy: 'row'
            })
          }
          return option
        default:
          return null
      }
    }
  },
  mounted () {
    this.valueData = clone(this.data)
    this.colorData = this.valueData.map(x => x.splice(1, 1))
  },
  methods: {
    getColorForForesight (index) {
      return this.colorData[index]
    }
  }
}
